<template>
  <span class="label label-default {!! $productLabel->tag !!}-label"
        :title="productLabel.name"
        :style="{'background-color': '#'+productLabel.color}"
  >
    {{ productLabel.tag }}
        {{ createdDate }}
</span>
</template>

<script>
import moment from 'moment'
import {DateFormatEnum} from "../../../enums";

export default {
  props: {
    productLabel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  created() {
  },
  computed: {
    createdDate() {
      if (this.productLabel !== null && this.productLabel.tag === 'hypotheekwacht' && this.productLabel.created_at !== null) {
        return moment(this.productLabel.created_at).format(DateFormatEnum.DATE)
      }
      return '';
    },
  },
  methods: {},
};
</script>

<style scoped>
.label-default {
  margin-right: .2rem;
  display: inline-block !important;
}
</style>
